// removed by extract-text-webpack-plugin
module.exports = {"block":"_3_P_0EhdNrKus0ktQYnxo6","header":"T01dEFdp_FuH2SdrE8tuW","content":"mrlPsbPJ5jzn3U6sR0cuK","items":"_1KOC6g6aMwwqE1PCcgvBB4","readMore":"_3JJroHFKyCOu06NgBdoLlN","footer":"znFY24_lUxQY38p4tLC1j"};


//////////////////
// WEBPACK FOOTER
// ./src/components/GalleryBlock/GalleryBlock.module.scss
// module id = 768
// module chunks = 0